import React from 'react'

import { UserContext } from 'components/OAuth'

export function useUser() {
	return React.useContext(UserContext)
}
